import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import type { GridFilterItem, GridSortModel } from "@mui/x-data-grid-premium";
import {
  BackendSortQueryParam,
  SortValue,
} from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.constants.ts";
import type { GetCatalog } from "@exonn/js-sdk";

export const useExonnHubCatalogParams = () => {
  const store = useExonnHubStore();

  const page = store.page;
  const pageSize = store.pageSize;
  const sortValue = store.sort;
  const showFavorite = store.showFavorite;
  const filterModels = store.filterModels;
  const categoryId = store.activeCategory;

  const dynamicFilters = filterModels.map((model) => {
    return {
      field: model.query_param,
      value:
        model.type === "checkbox"
          ? model.values.join(",")
          : model.value.join(","),
      operator: "exact",
    };
  });

  const getItems = () => {
    const items: GridFilterItem[] = [];
    if (store.search) {
      items.push({
        field: "search",
        value: store.search || undefined,
        operator: "partial",
      });
    }
    if (categoryId) {
      items.push({
        field: "category_id",
        value: categoryId,
        operator: "exact",
      });
    }
    if (showFavorite) {
      items.push({
        field: "is_favourite",
        value: "true",
        operator: "is",
      });
    }

    return [...items, ...dynamicFilters];
  };

  const getSort = () => {
    if (sortValue && sortValue !== SortValue.Default) {
      return [
        {
          field: BackendSortQueryParam.UnitPrice,
          sort: sortValue === SortValue.CheapFirst ? "asc" : "desc",
        },
      ] as GridSortModel;
    }
    return undefined;
  };

  const params: GetCatalog.QueryParameters = {
    page: {
      number: page,
      size: pageSize,
    },
    sort: getSort(),
    filter: {
      items: getItems(),
    },
  };
  return params;
};
